export default __webpack_public_path__ + "static/tooltip-interactive-2-do-dark-67f5e8e4ef2b54667040696b2b90f8b1.png";